import { render, staticRenderFns } from "./AllCommentPage.vue?vue&type=template&id=48fe3205&scoped=true&"
import script from "./AllCommentPage.vue?vue&type=script&lang=js&"
export * from "./AllCommentPage.vue?vue&type=script&lang=js&"
import style0 from "./AllCommentPage.vue?vue&type=style&index=0&id=48fe3205&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fe3205",
  null
  
)

export default component.exports